<template>
    <label
        :class="[
            'radio-field',
            {
                'radio-field_checked': isChecked,
                'radio-field_disabled': disabled,
            },
        ]"
    >
        <input
            :id="id"
            type="radio"
            :value="value"
            :checked="isChecked"
            :disabled="disabled"
            class="radio-field__input"
            @change="onChange"
        />

        <span class="radio-field__custom"></span>

        <span class="radio-field__title">
            <label :for="id">{{ label }}</label>
        </span>
    </label>
</template>

<script lang="ts" setup>
    import { inject, computed } from 'vue';

    const props = defineProps({
        value: {
            type: [String, Number, Boolean],
            required: true,
        },
        id: {
            type: String,
            required: true,
        },
        label: {
            type: [String, Number],
            required: true,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    });

    const radioGroup = inject('radioGroup');

    if (!radioGroup) {
        console.error('UIRadio must be used inside UIRadioGroup');
    }

    const isChecked = computed(() => {
        return radioGroup?.modelValue.value === props.value;
    });

    const onChange = (): void => {
        if (radioGroup) {
            radioGroup.updateModelValue(props.value);
        }
    };
  </script>

<style lang="scss" scoped>
    @use './UIRadio.scss' as *;
</style>
